export default __webpack_public_path__ + "static/media/WonderBlockly.fe1d284a.webp";